import selectedService from "./selectedService";

export default selectedService;
